import HttpCliente from "../HttpCliente";

export const getConfiguracionesCorreoCliente = (token) => {
  return new Promise((resolve, reject) => {
    HttpCliente.get("/ConfiguracionCorreoCliente/ObtenerConfiguraciones", {
      headers: {
        "Authorization": `Bearer ${token}`,
        'accept': 'text/plain'
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      reject(error);
    });
  });
};

export const getConfiguracionesCorreoClienteHabilitadas = (token) => {
  return new Promise((resolve, reject) => {
    HttpCliente.get("/ConfiguracionCorreoCliente/ObtenerConfiguracionesHabilitadas", {
      headers: {
        "Authorization": `Bearer ${token}`,
        'accept': 'text/plain'
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      reject(error);
    });
  });
};

export const postConfiguracionCorreoCliente = (token, configuracion) => {
  return new Promise((resolve, reject) => {
    HttpCliente.post("/ConfiguracionCorreoCliente/Crear", configuracion, {
      headers: {
        "Authorization": `Bearer ${token}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      reject(error);
    });
  });
};

export const putConfiguracionCorreoCliente = (token, configuracion) => {
  return new Promise((resolve, reject) => {
    HttpCliente.put("/ConfiguracionCorreoCliente/EditarConfiguracion", configuracion, {
      headers: {
        "Authorization": `Bearer ${token}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      reject(error);
    });
  });
};

export const getConfiguracionCorreoClienteById = (token, id) => {
  return new Promise((resolve, reject) => {
    HttpCliente.get(`/ConfiguracionCorreoCliente/ObtenerConfiguracion/${id}`, {
      headers: {
        "Authorization": `Bearer ${token}`,
        'accept': 'text/plain'
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      reject(error);
    });
  });
};

export const deleteConfiguracionCorreoCliente = (token, id) => {
  return new Promise((resolve, reject) => {
    HttpCliente.delete(`/ConfiguracionCorreoCliente/Deshabilitar/${id}`, {
      headers: {
        "Authorization": `Bearer ${token}`,
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      reject(error);
    });
  });
};

export const getVistaPreviaCorreo = (token, configuracionId) => {
  return new Promise((resolve, reject) => {
    HttpCliente.get(`/ConfiguracionCorreoCliente/VistaPreviaCorreo/${configuracionId}`, {
      headers: {
        "Authorization": `Bearer ${token}`,
        'accept': 'text/html'
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      reject(error);
    });
  });
};